import { memo } from "react";
import { classNames } from "helpers";
import { FINANCIAL_TABS } from "../../consts";
import { FinancialTabMenuProps } from "../../types";

/**
 * Traka tabova unutar zaglavlja, kao na detaljnim ekranima. Ondje su tabovi rute pa idu
 * kroz `NavLink`; ovdje su četiri pogleda nad istim razdobljem, pa se stanje drži u
 * `?tab=` — izgled je isti.
 */
const TabMenu: React.FC<FinancialTabMenuProps> = ({ activeTab, onTabChange }) => (
  <div className="flex border-b border-slate-200 bg-white overflow-x-auto scrollbar-hide">
    {FINANCIAL_TABS.map((tab) => {
      const handleClick = () => onTabChange(tab.value);

      return (
        <button
          key={tab.value}
          type="button"
          onClick={handleClick}
          className={classNames(
            "shrink-0 font-semibold px-4 py-2 ml-3 first:ml-3 whitespace-nowrap hover:text-sky-600 focus:outline-none",
            activeTab === tab.value
              ? "text-sky-600 border-b-2 border-b-sky-600"
              : "text-gray-600"
          )}
        >
          {tab.label}
        </button>
      );
    })}
  </div>
);

export default memo(TabMenu);
